import React from 'react';

class Expandable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    }
  }

  toggle = () => {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  }

  render() {
    const {
      title,
      children,
    } = this.props;
    
    const {
      expanded
    } = this.state;

    return (
      <div className='component-expandable'>
        <div className='header' onClick={this.toggle}>
          <i className={`fa ${expanded ? 'fa-chevron-down' : 'fa-chevron-right' }`} />
          {title}
        </div>
        {
          expanded &&
          <div className='body'>
            {children}
          </div>
        }
      </div>
    );
  }
}

export default Expandable;